import { Link } from 'react-router-dom';
import '../App.css';
import Header from '../components/Header';
import { Helmet } from 'react-helmet-async';

const MONITORING_DASHBOARD_SRC =
  'https://app.powerbi.com/view?r=eyJrIjoiNGVkOTNiNGItZDkyNy00N2RjLWFiMzYtN2M0ODUyYmRmYjViIiwidCI6ImUzNmQ3NWZhLWU4NjItNDAyMC05MzllLTU0YjFiNDQ2NGFlMSJ9';

function Monitoring() {
  return (
    <>
      <Helmet>
        <title>Resident Monitoring Dashboard | Whitstable House</title>
        <meta
          name="description"
          content="Whitstable House resident monitoring dashboard. Live operational view for authorised use."
        />
        <link rel="canonical" href="https://www.whitstable.house/monitoring" />
      </Helmet>

      <div className="page">
        <a href="#main-content" className="skip-link">
          Skip to main content
        </a>
        <Header />

        <main id="main-content">
          <section className="content-section monitoring-page">
            <div className="monitoring-container">
              <h1>Resident Monitoring Dashboard</h1>
              <div className="power-bi-iframe-wrapper">
                <iframe
                  title="Whitstable Resident Monitoring Dashboard"
                  src={MONITORING_DASHBOARD_SRC}
                  className="power-bi-iframe"
                  allowFullScreen
                />
              </div>
            </div>
          </section>
        </main>

        <footer className="footer">
          <section className="footer__enquiry">
            <div className="footer__enquiry-container">
              <Link to="/contact-us" className="footer__enquiry-link">
                Enquire about Whitstable House <span className="footer__arrow">▶</span>
              </Link>
            </div>
          </section>
          <div className="footer__container">
            <section className="contact-section">
              <div className="contact-section__content">
                <p>Whitstable House, Boorman Way, Whitstable CT5 3SE</p>
                <p>Copyright © Whitstable House</p>
              </div>
            </section>
          </div>
        </footer>
      </div>
    </>
  );
}

export default Monitoring;
